import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import Login from '../views/auth/Login'

import Home from '../views/home/Home'
import Search from '../views/search/Search'

import Autorisations from "../views/autorisations/Autorisations";

import ProfileShow from "../views/user/ProfileShow";
import ProfileEdit from "../views/user/ProfileEdit";
import MyLampions from "../views/user/MyLampions";
import MyMatches from "../views/user/MyMatches";
import MyFavorites from "../views/user/MyFavorites";

import AnnonceShow from "../views/annonce/AnnonceShow";
import AnnonceCreate from "../views/annonce/AnnonceCreate/AnnonceCreate";

import AnnonceAdditionnalRewardEdit from "../views/annonce/AnnonceAdditionnalRewardEdit";
import AnnonceBoostEdit from "../views/annonce/AnnonceBoostEdit";

import MyAnnonce from "../views/user/MyAnnonce";
import MyAlerts from "../views/user/MyAlerts";

import VerifyMatch from "../views/match/VerifyMatch";


Vue.use(VueRouter)

const routes = [


  {
    path: '/login/:component?/:token?/:userId?',
    name: 'Login',
    component: Login,
    meta: {
      guest: true
    }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_INDIVIDUAL_UNCONFIRMED', 'ROLE_INDIVIDUAL_CONFIRMED', 'ROLE_INDIVIDUAL_SUPER_WATCHER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']
    }
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_INDIVIDUAL_UNCONFIRMED', 'ROLE_INDIVIDUAL_CONFIRMED', 'ROLE_INDIVIDUAL_SUPER_WATCHER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']
    }
  },

  {
    path: '/user/profileShow',
    name: 'ProfileShow',
    component: ProfileShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_INDIVIDUAL_UNCONFIRMED', 'ROLE_INDIVIDUAL_CONFIRMED', 'ROLE_INDIVIDUAL_SUPER_WATCHER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']
    }
  },

  {
    path: '/user/profileEdit',
    name: 'ProfileEdit',
    component: ProfileEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_INDIVIDUAL_UNCONFIRMED', 'ROLE_INDIVIDUAL_CONFIRMED', 'ROLE_INDIVIDUAL_SUPER_WATCHER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']
    }
  },

  {
    path: '/user/myLampions',
    name: 'MyLampions',
    component: MyLampions,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_INDIVIDUAL_UNCONFIRMED', 'ROLE_INDIVIDUAL_CONFIRMED', 'ROLE_INDIVIDUAL_SUPER_WATCHER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']
    }
  },

  {
    path: '/user/myMatches',
    name: 'MyMatches',
    component: MyMatches,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_INDIVIDUAL_UNCONFIRMED', 'ROLE_INDIVIDUAL_CONFIRMED', 'ROLE_INDIVIDUAL_SUPER_WATCHER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']
    }
  },

  {
    path: '/user/myFavorites',
    name: 'MyFavorites',
    component: MyFavorites,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_INDIVIDUAL_UNCONFIRMED', 'ROLE_INDIVIDUAL_CONFIRMED', 'ROLE_INDIVIDUAL_SUPER_WATCHER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']
    }
  },

  {
    path: '/autorisations',
    name: 'Autorisations',
    component: Autorisations,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_INDIVIDUAL_UNCONFIRMED', 'ROLE_INDIVIDUAL_CONFIRMED', 'ROLE_INDIVIDUAL_SUPER_WATCHER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']
    }
  },

  {
    path: '/annonce/create',
    name: 'AnnonceCreate',
    component: AnnonceCreate,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_INDIVIDUAL_UNCONFIRMED', 'ROLE_INDIVIDUAL_CONFIRMED', 'ROLE_INDIVIDUAL_SUPER_WATCHER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']
    }
  },

  {
    path: '/annonce/edit/:annonceId?',
    name: 'AnnonceEdit',
    component: AnnonceCreate,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_INDIVIDUAL_UNCONFIRMED', 'ROLE_INDIVIDUAL_CONFIRMED', 'ROLE_INDIVIDUAL_SUPER_WATCHER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']
    }
  },

  {
    path: '/annonce/show/:annonceId?',
    name: 'AnnonceShow',
    component: AnnonceShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_INDIVIDUAL_UNCONFIRMED', 'ROLE_INDIVIDUAL_CONFIRMED', 'ROLE_INDIVIDUAL_SUPER_WATCHER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']
    }
  },

  {
    path: '/annonce/additionnalReward/:annonceId?',
    name: 'AnnonceAdditionnalRewardEdit',
    component: AnnonceAdditionnalRewardEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_INDIVIDUAL_UNCONFIRMED', 'ROLE_INDIVIDUAL_CONFIRMED', 'ROLE_INDIVIDUAL_SUPER_WATCHER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']
    }
  },

  {
    path: '/annonce/boost/:annonceId?',
    name: 'AnnonceBoostEdit',
    component: AnnonceBoostEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_INDIVIDUAL_UNCONFIRMED', 'ROLE_INDIVIDUAL_CONFIRMED', 'ROLE_INDIVIDUAL_SUPER_WATCHER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']
    }
  },

  {
    path: '/user/myAnnonce',
    name: 'MyAnnonce',
    component: MyAnnonce,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_INDIVIDUAL_UNCONFIRMED', 'ROLE_INDIVIDUAL_CONFIRMED', 'ROLE_INDIVIDUAL_SUPER_WATCHER']
    }
  },

  {
    path: '/user/MyAlerts',
    name: 'MyAlerts',
    component: MyAlerts,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_INDIVIDUAL_UNCONFIRMED', 'ROLE_INDIVIDUAL_CONFIRMED', 'ROLE_INDIVIDUAL_SUPER_WATCHER']
    }
  },

  {
    path: '/match/verifyMatch',
    name: 'VerifyMatch',
    component: VerifyMatch,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_INDIVIDUAL_UNCONFIRMED', 'ROLE_INDIVIDUAL_CONFIRMED', 'ROLE_INDIVIDUAL_SUPER_WATCHER']
    }
  },

  {
    path: '/openapp',
    redirect: to => {
      const { query } = to;
      if (query && query.id) {
        const { id, ...restQuery } = query; // Déstructuration pour enlever 'id' de query
        return { path: `/annonce/show/${id}`, query: restQuery };
      } else {
        return '/'; // Redirection par défaut si l'id n'est pas spécifié
      }
    }
  },

]

const router = new VueRouter({
  routes
})

// the meta: {requiresAuth: true} key. If a route has the meta key, it checks the store for a token; if present, it redirects them to the login route.
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const checkRoles = to.matched.some(record => {
      return record.meta.roles && store.getters.roles.some(r => record.meta.roles.includes(r)) && store.getters.isAuthenticated
    })


    if (checkRoles) {
      next()
      return
    } else if (store.getters.isAuthenticated) {
      next('/')
      return
    } else {
      next('/login')
      return
    }

    // Gestion pages réservées aux utilisateurs connectés
    // eslint-disable-next-line no-unreachable
    if (store.getters.isAuthenticated) {
      next()
    }
    next('/login')
  } else {
    next()
  }
})

// The meta: {guest: true} stops users that are logged in from accessing the routes with the guest meta.
router.beforeEach((to, from, next) => {
  console.log(to)
  console.log(to.matched.some((record) => record.meta.guest))
  if (to.matched.some((record) => record.meta.guest)) {
    if (store.getters.isAuthenticated) {
      next('/')
      return
    }
    next()
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js